import * as Yup from 'yup';

export type PaymentFormProps = {
  paymentType: string;
  value: number;
  total: number;

  dueDate: string;
  bankAccount: string;
};
export const initialValues: PaymentFormProps = {
  paymentType: 'pix',
  value: 0,
  total: 0,
  dueDate: '',
  bankAccount: '',
};

const requiredFieldError = 'Campo obrigatório';
const maxValueError = 'Valor excedete o valor máximo';

export const validationSchema = (maxValue: number) =>
  Yup.object().shape({
    value: Yup.number()
      .max(maxValue)
      .test('isValidValue', maxValueError, (val) => Number(val) <= maxValue),
    paymentType: Yup.string().required(requiredFieldError),

    dueDate: Yup.date(),

    bankAccount: Yup.string()
      .when('paymentType', {
        is: 'px',
        then: Yup.string()
          .required(requiredFieldError)
          .test((el) => !!el?.trim()),
      })
      .when('paymentType', {
        is: 'bt',
        then: Yup.string()
          .required(requiredFieldError)
          .test((el) => !!el?.trim()),
      })
      .when('paymentType', {
        is: 'bs',
        then: Yup.string()
          .required(requiredFieldError)
          .test((el) => !!el?.trim()),
      }),
  });

export default initialValues;
